<template>
  <div class="min-vh-100 d-flex flex-row" style="background-image: url('/logo/logInBg.png')">
    <CContainer class="mt-5">
      <div class="row justify-content-center" style="height: 90%;">
        <div class="text-center col-lg-8 col-md-10 col-sm-12" style="
        background-color: rgba(255, 255, 255, 0.5);
        border-radius: 10px;
      ">
          <div class="row justify-content-center" style="height: 100%;">
            <div class="col-md-8 col-sm-10 p-4 align-self-center" style="max-height: 600px;">
              <div class="row" style="height: 90%;">
                <img src="/logo/rafi_pay.png" class="rounded img-fluid" alt="..." style="object-fit: cover; " />
              </div>
              <div class="row justify-content-center mt-3">
                <CButton style="max-width: 200px; background-color: #446982;" @click="signInWithOffice365()">
                  <span style="color: white;">Login</span>
                </CButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CContainer>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import Swal from 'sweetalert2'
import 'sweetalert2/src/sweetalert2.scss'
import { mount } from '@vue/test-utils'
import auth from '@/auth'
import { reactive, computed } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import {
  required,
  email,
  minLength,
  sameAs,
  helpers,
} from '@vuelidate/validators'
import { PublicClientApplication } from '@azure/msal-browser'
import msalInstance from '../msal'
export default {
  mounted() {
    this.clearToken()
  },
  methods: {
    clearToken() {
      localStorage.removeItem('UserInfo')
      localStorage.removeItem('BearerToken')
      localStorage.removeItem('BusinessUnitId')
      localStorage.removeItem('DepartmentId')
      localStorage.removeItem('legalEnt')
      localStorage.removeItem('SSOToken')

      console.log('Local Storage Cleared')
    },
    async signInWithOffice365() {
      await msalInstance.initialize()
      this.loading()
      try {
        const response = await msalInstance.loginPopup({
          scopes: ['User.Read'],
          redirectUri: window.location.origin,
        })
        console.log('Authentication successful:', response)
        const accessToken = response.accessToken
        localStorage.setItem('SSOToken', accessToken)
        localStorage.setItem('Ok', true);
        const user = response.account

        this.authToken()
        setTimeout(() => {
          this.getuserinfo(accessToken)
        }, 3000)

      } catch (error) {
        console.error('Authentication error:', error)
        Swal.close()
      }
    },
    async authToken() {
      try {
        let response = await axios.get(process.env.VUE_APP_SEEDAPI, {
          params: {
            tenant_id: process.env.VUE_APP_TENANT_ID,
            client_id: process.env.VUE_APP_CLIENT_ID,
            grant_type: process.env.VUE_APP_GRANT_TYPE,
            client_secret: process.env.VUE_APP_CLEINT_SECRET,
            resource: process.env.VUE_APP_RESOURCES,
          },
        })
        this.bearerToken = response.data.data.access_token

      } catch (error) {
        Swal.close()
        console.log(error)
      }
    },
    async login() {
      await this.authToken()
      let userInfo = {
        $id: '1',
        Status: 'Success',
        EmployeeID: 'ID000005606',
        AllowedToChangeLegalEntity: false,
        DefaultBusinessUnit: 'ITU',
        DefaultDepartment: 'ITU-GEN',
        DefaultProgram: '',
        DefaultProject: '',
        DefaultActivity: '',
        DefaultCostCenter: '',
        AllowedToChangeFinancialDimensions: false,
        UserIsAnApprover: false,
        DisplayName: 'Jade Ryan Trazo Gadiane',
        DefaultLegalEntity: 'RAFI',
      }
      localStorage.setItem('UserInfo', JSON.stringify(userInfo))

      this.$router.push({ name: 'REQUEST FOR PAYMENT' })
    },
    async authToken() {
      try {
        let response = await axios.get(process.env.VUE_APP_SEEDAPI, {
          params: {
            tenant_id: process.env.VUE_APP_TENANT_ID,
            client_id: process.env.VUE_APP_CLIENT_ID,
            grant_type: process.env.VUE_APP_GRANT_TYPE,
            client_secret: process.env.VUE_APP_CLEINT_SECRET,
            resource: process.env.VUE_APP_RESOURCES,
          },
        })
        this.bearerToken = response.data.data.access_token
      } catch (error) {
        Swal.close()
        console.log(error)
      }
    },
    async getuserinfo(token) {
      const url = process.env.VUE_APP_GRAPHUSERINFO
      const config = {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      }
      try {
        let response = await axios.get(url, {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        })
        const UserInfo = JSON.stringify(response.data)
        localStorage.setItem('email', response.data.email)

        this.validateUser(response.data.email)
      } catch (error) {
        Swal.close()
        console.log(error)
      }
    },
    async validateUser(email) {
      const mails = localStorage.getItem('email');
      const mail = email == null ? mails : email;

      const url =
        '/api/services/RAFIPAYIntegration/RAFIPayUserAPI/Authorization'
      this.loading()
      try {
        const payload = {
          RAFIPayIntegration: {
            EmailAddress: mail,
          },
        }
        let response = await axios.post(url, payload, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Access-Control-Allow-Origin': '*',
            Authorization: 'Bearer ' + this.bearerToken,
          },
        })

        if (response.data.Status == 'Success') {
          Swal.close()
          localStorage.setItem('BearerToken', this.bearerToken)
          localStorage.setItem('UserInfo', JSON.stringify(response.data))
          localStorage.setItem('legalEnt', response.data.DefaultLegalEntity)
          window.location.replace('/list-of-rfps/request-list')
          router.push('/list-of-rfps/request-list/');

        } else {
          Swal.close()
          this.swalMessage(
            'error',
            'Unauthorized Access',
            'You are not authorized to access this page',
          )
        }
      } catch (error) {
        Swal.close()

      }
    },

    loading(text) {
      Swal.fire({
        title: text,
        didOpen() {
          Swal.showLoading()
        },
        allowOutsideClick: false,
        showCancelButton: false,
      })
    },

    swalMessage(icon, title, text) {
      Swal.fire({
        icon: icon,
        title: title,
        text: text,
      })
    },
  },
}
</script>
<style lang="scss">
.image {
  height: auto;
}

@media (max-width: 762px) {

  .image {
    height: 20vh;
  }
}
</style>
